// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1eOtD","options":"AnswerScale_options__3WJZ9","selected":"AnswerScale_selected__25O6y"};